// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__5Svbj","rotate":"Loader_rotate___8rUY","loaderreverse":"Loader_loaderreverse__Kg9NH"};